// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Grid from "@material-ui/core/Grid";

// Import Pages
import { libraryIcons } from '../../../autom/NewFlowLibraryAssetManager';
import { getImageColors, getShade, checkDifferentLibraryShade } from '../../../../../../helpers/helper'

// Import Icons
import InfoIcon from '../../../../../../assets/icons/info-icon.svg';

// Import CSS
import '../ModuleItem/ModuleItem.css';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';

const defaultLibraryImg = `default_library.png`

const LibraryItem = ({
    img,
    img_path,
    name,
    library,
    isEhFlow,
    actions,
    handleDragStart,
    handleDragEnd,
    isDesktopRecorder,
    categoryModuleName,
    openAddActionsByClickDialog
}) => {
    const { t } = useTranslation();

    const [expand, setExpand] = useState(false);
    const [dynamicBackgrounColor, setDynamicBackgrounColor] = useState('#666469');
    const [dynamicColor, setDynamicColor] = useState('white');
    const [shade, setShade] = useState('');

    useEffect(() => {
        getImageColors(img, (result) => {
            if (!library.visible) {
                return
            }
            const isUniqe = checkDifferentLibraryShade(library.library_name)
            setDynamicBackgrounColor(isUniqe.dynamicBg ? isUniqe.dynamicBg : result.background);
            setShade(isUniqe.shade ? isUniqe.shade : getShade(result.background, 75));
            setDynamicColor(result.color);
        })
    }, [isEhFlow]);

    const checkEnabledActions = (library, action) => {
        if ((library.library_name === "DESKTOP-ACTIONS" && action.action_name !== "SCOPE" && !isDesktopRecorder) ||
            (library.library_name === "FILE" && ["OPEN", "PRINT"].includes(action.action_name)) ||
            (library.library_name === "PDF" && ["EXPORT-TO-EXCEL"].includes(action.action_name)) ||
            (isEhFlow && library.library_name === "ADVANCED-ACTIONS" && ["RUN-COMMAND"].includes(action.action_name))) {
            return false
        }
        return true
    }

    const getLearnLinkByModuleName = (actionName) => {
        const docs = "https://docs.autommate.com/userguide/libraries/";
        let link
        switch (categoryModuleName) {
            case 'VARIABLES':
                // return docs + `variables/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                link = docs + `variables/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                break;
            case 'APPS':
                // return docs + `integration/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                link = docs + `integration/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                break;
            case 'ADVANCED-ACTIONS':
                // return docs + `transform/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                link = docs + `transform/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                break;
            case 'AI-ACTIONS':
            case 'UTILITIES':
                // return docs + `utility/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                link = docs + `utility/${library.library_name.toLowerCase()}#${actionName?.toLowerCase()}`;
                break;
            case 'UI-ACTIONS':
                // return docs + "ui-actions";
                link = docs + "ui-actions";
                break;
            default:
                link = docs
                break;
        }
        if (link) {
            link = link.replace(/ /g, "-");
        }
        return link
    }

    return (
        <div className={!isDesktopRecorder && "library-item-container font-manrope"}>
            <div className={!isDesktopRecorder && "library-item-padding"}>
                {!isDesktopRecorder &&
                    <div className="ml-item-header library-item-header">
                        <div className="module-item-title-container">
                            <img loading="lazy" src={img} className="library-img" alt={name} />
                            <span className="module-item-title">{name}</span>
                        </div>
                        {expand ? <KeyboardArrowUp className="module-item-expand" onClick={() => setExpand(false)} /> : <KeyboardArrowDown className="module-item-expand" onClick={() => setExpand(true)} />}
                    </div>
                }
                {
                    (expand || isDesktopRecorder) &&
                    <div className={!isDesktopRecorder && "module-item-content"}>
                        {
                            actions.length > 0 &&
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between" spacing={1}>
                                    {
                                        actions.map((action, index) => {
                                            let currentVersion = library.library_versions.filter(version => version.is_active);
                                            const action_name = library?.library_label?.includes('CUSTOM') ? action?.action_name :
                                                t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`);
                                            if (action.visible) {
                                                // Actions to be hidden by rule or empty configuration form
                                                if (!checkEnabledActions(library, action)) return
                                                return (
                                                    <Grid item xs={12} sm={6} key={index}>
                                                        <div className='action-item-container'
                                                            onClick={(e) => isDesktopRecorder && openAddActionsByClickDialog(e, {
                                                                ...action,
                                                                libraryLabel: library.library_label,
                                                                libraryName: library.library_name,
                                                                application_id: library.application_id,
                                                                actionName: action.action_name,
                                                                library_label: library.library_label,
                                                                library_name: library.library_name,
                                                                action_name: action.action_name,
                                                                image: img_path,
                                                                image_path: img_path,
                                                                shade,
                                                                fields: {},
                                                                isDebugging: false,
                                                                debugStatus: "",
                                                                debugErrorMessage: "",
                                                                version: currentVersion[0]?.version,
                                                                versionId: currentVersion[0]?.id,
                                                                actionId: action.id
                                                            })}
                                                            onDragStart={(e) => handleDragStart(e,
                                                                {
                                                                    ...action,
                                                                    libraryLabel: library.library_label,
                                                                    libraryName: library.library_name,
                                                                    application_id: library.application_id,
                                                                    actionName: action.action_name,
                                                                    library_label: library.library_label,
                                                                    library_name: library.library_name,
                                                                    action_name: action.action_name,
                                                                    image: img,
                                                                    image_path: img_path,
                                                                    shade,
                                                                    fields: {},
                                                                    isDebugging: false,
                                                                    debugStatus: "",
                                                                    debugErrorMessage: "",
                                                                    version: currentVersion[0]?.version,
                                                                    versionId: currentVersion[0]?.id,
                                                                    actionId: action.id
                                                                }
                                                            )}
                                                            draggable={!!action.status}
                                                            onDragEnd={(e) => handleDragEnd(e,
                                                                {
                                                                    ...action,
                                                                    libraryLabel: library.library_label,
                                                                    libraryName: library.library_name,
                                                                    application_id: library.application_id,
                                                                    actionName: action.action_name,
                                                                    library_label: library.library_label,
                                                                    library_name: library.library_name,
                                                                    action_name: action.action_name,
                                                                    image: img,
                                                                    image_path: img_path,
                                                                    shade,
                                                                    fields: {},
                                                                    isDebugging: false,
                                                                    debugStatus: "",
                                                                    debugErrorMessage: "",
                                                                    version: currentVersion[0]?.version,
                                                                    versionId: currentVersion[0]?.id,
                                                                    actionId: action.id
                                                                }
                                                            )}
                                                        >
                                                            <img loading="lazy" src={img} className="library-img-in-action" alt={name} />
                                                            <div className='action-item-name' style={{ backgroundColor: dynamicBackgrounColor, color: dynamicColor }}>
                                                                {action_name}
                                                            </div>
                                                            <Tooltip title={t(`MESSAGES.LIBRARY.ACTION-DOCUMENTATION`)} placement="top">
                                                                <Link target='_blank' to={getLearnLinkByModuleName(action.action_name)} className="action-info-icon"><img loading="lazy" src={InfoIcon} alt={name} /></Link>
                                                            </Tooltip>
                                                        </div>

                                                    </Grid>
                                                )
                                            }
                                        })
                                    }
                                </Grid>
                            </Grid>

                        }
                    </div>
                }
            </div>
        </div >
    )
}

export default LibraryItem;